// Theming

let config = JSON.parse(sessionStorage.getItem("tenantConfig")) || {};
export const colorSwitcherOne =
  config.colorSwitcherOne || config.ButtonandLeftBarColor || "#000000";
export const colorSwitcherTwo =
  config.colorSwitcherTwo || config.BordersColor || "#45719b";
export const colorSwitcherThree =
  config.colorSwitcherThree || config.BordersColor || "#4d719b";
export const loginTopBoxShadow =
  config.loginTopBoxShadow || config.BordersColor || "#3d719b";
export const loginBackgroundColor = config.loginBackgroundColor || "#3d719b";
export const forgotFontColor = config.forgotFontColor || "#7f1734";
export const buttonFontColor = config.buttonFontColor || "#ffffff";
export const disableButtonColor = config.disableButtonColor || "#c1c1c1";
export const allHeaderFontSize = config.allHeaderFontSize || "1.2rem";
export const allTitleFontSize = config.allTitleFontSize || "1rem";
export const logoHeight = config.bigLogoHeight || "45px";
export const logoWidth = config.bigLogoWidth || "auto";
export const smallLogoHeight = config.smallLogoHeight || "40px";
export const smallLogoWidth = config.smallLogoWidth || "auto";
export const isSmallLogoAvailable = config.logoSmallUrl || false;
export const ButtonandLeftBarColor =
  config.ButtonandLeftBarColor || config.colorSwitcherOne || "#000000";
